<template>
  <b-modal
      id="verify-email"
      ref="verify-email"
      size="purchase-successful"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      hide-header
      @hide="onClose"
  >
    <div class="modal-head">
      <i class="verify-email-icon" />
      <h4 v-if="!confirmed">{{ label.get('verify_your_email_address') }}</h4>
      <h4 v-if="confirmed">{{ label.get('sign_up_confirm_email') }}</h4>
    </div>
    <div class="content-wrapper">
      <p v-if="!confirmed">
        {{ label.get('verify_your_email_address_p_one') }}
      </p>
      <div class="custom-input-wrapper" v-if="!confirmed">
        <label class="email-in-use">{{ label.get('email_address_in_use') }}</label>
        <input type="email" class="atto-input" name="email" v-model="email" placeholder="email@example.com"/>
        <span class="error-message" v-if="error">{{label.get('enter_valid_email_address')}}</span>
      </div>
      <p v-if="!confirmed">
        {{ label.get('verify_your_email_address_p_two') }}
      </p>
      <p v-if="confirmed" v-html="label.get('sign_up_confirm_description_verify', {email: email})"></p>
    </div>
    <div class="modal-footer">
      <button
          v-if="!confirmed"
          :disabled="disabled"
          type="button"
          class="atto-btn submit"
          @click="verify"
      >
        {{ label.get('resend_verification_email') }}
      </button>
      <button
          v-if="!confirmed"
          :disabled="disabled"
          type="reset"
          class="atto-btn close"
          @click="onClose"
      >
        {{ label.get('not_now') }}
      </button>
      <button
          v-if="confirmed"
          type="reset"
          class="atto-btn close"
          @click="onClose"
      >
        {{ label.get('continue') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import UserService from "../../features/settings/services/UserService";

export default {
  name: "VerifyEmailComponent",
  data() {
    return {
      email: this.$store.state.user.email,
      error: false,
      confirmed: false,
      disabled: false
    }
  },
  mounted() {
    this.$refs['verify-email'].show();
  },
  methods: {
    onClose() {
      this.$root.$emit('onHideVerifyEmail');
    },
    verify() {
      debugger;
      this.error = false;
      if(this.email === undefined || this.email === null || this.email === '') {
        this.error = true;
         return false;
      }
      this.disabled = true;
      UserService.resendActivateAccount({email: this.email}).then((response) => {
        this.confirmed = true;
      }).catch((error) => {
        this.error = true;
        this.disabled = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.modal-content {
  .modal-body {
    .content-wrapper {
      padding: 12px 48px 24px 48px !important;

      p {
        padding-left: 25px;
        padding-right: 25px;
      }
      .custom-input-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 0;

        input {
          width: 100%;
          border: 2px solid #EFEFEF;
          border-radius: 0;
          padding: 11px;
          color: $atto-font-color;
          font-family: "Roboto", sans-serif;
          font-size: 0.875rem;
          line-height: 1rem;
          text-align: center;

          &:focus {
            border-color: #999;
          }

          &[type=number] {
            -webkit-appearance: none;
            -moz-appearance: textfield;
            margin: 0;
          }
        }

        label.email-in-use {
          width: auto;
          color: #999999;
          font-size: 10px;
          font-family: "Roboto", sans-serif;
          font-weight: 500;
          letter-spacing: 0.5px;
          line-height: 11px;
          text-align: center;
          text-transform: uppercase;
        }

        .error-message {
          text-align: center;
        }
      }
    }
  }
  .modal-footer {
    display: flex;
    flex-direction: column;

    .atto-btn {
      width: 100%;
      padding: 0;
      margin: 0;

      &.close {
        border: 2px solid #EFEFEF;
        margin-top: 12px;
        font-weight: 400;
        color: #666666;
        opacity: 1;
      }
    }
  }
}
</style>